import { TypeMismatchError, StandardResolutionReasons } from '@openfeature/core';

function toResolutionDetails(type, value, data, reason) {
    var _a;
    if (!isType(type, value)) {
        throw new TypeMismatchError(`Requested ${type} flag but the actual value is ${typeof value}`);
    }
    const matchedTargeting = data.matchedTargetingRule;
    const matchedPercentage = data.matchedPercentageOption;
    const matchedRule = Boolean(matchedTargeting || matchedPercentage);
    const evaluatedReason = matchedRule ? StandardResolutionReasons.TARGETING_MATCH : StandardResolutionReasons.STATIC;
    return {
        value,
        reason: reason !== null && reason !== void 0 ? reason : evaluatedReason,
        errorMessage: data.errorMessage,
        variant: (_a = data.variationId) !== null && _a !== void 0 ? _a : undefined,
    };
}
function isType(type, value) {
    return typeof value !== 'undefined' && typeof value === type;
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function toUserAttributeValue(value) {
    if (typeof value === 'string' || typeof value === 'number' || value instanceof Date) {
        return value;
    }
    else if (Array.isArray(value) && value.every((item) => typeof item === 'string')) {
        return value;
    }
    return JSON.stringify(value);
}
function transformCustomContextValues(contextValue) {
    if (typeof contextValue !== 'object' || contextValue === null) {
        return {};
    }
    return Object.entries(contextValue).reduce((context, [key, value]) => {
        const transformedValue = toUserAttributeValue(value);
        return transformedValue ? Object.assign(Object.assign({}, context), { [key]: transformedValue }) : context;
    }, {});
}
function stringOrUndefined(param) {
    if (typeof param === 'string') {
        return param;
    }
    return undefined;
}
function transformContext(context) {
    const { targetingKey, email, country } = context, attributes = __rest(context, ["targetingKey", "email", "country"]);
    if (!targetingKey) {
        return undefined;
    }
    return {
        identifier: targetingKey,
        email: stringOrUndefined(email),
        country: stringOrUndefined(country),
        custom: transformCustomContextValues(attributes),
    };
}

export { isType, toResolutionDetails, transformContext };
